// Partnership bidding labels, shared by the bidding page and Just Play's "Waiting for you" list.
// Neutral structural labels (Paul supplies any wording beyond names).

// Topics, in the order they are offered. A pool the backend has but this list lacks is not offered.
export const TOPIC_LABEL = {
  all: "All topics",
  slam: "Slams",
  jacoby: "Jacoby hands",
  game: "Games",
  competitive: "Competitive",
  swing: "Big swings",
  random: "Random",
};

// Famous pairs (Paul, 19-20 Oct 2026), shown under one "Famous pairs" choice.
export const PAIR_LABEL = {
  "brink+drijver": "Brink–Drijver",
  "gawrys+klukowski": "Gawrys–Klukowski",
  "levin+weinstein": "Levin–Weinstein",
  "hurd+bathurst": "Hurd–Bathurst",
  "demuy+kranyak": "Demuy–Kranyak",
  "pachtmann+zatorski": "Pachtmann–Zatorski",
  "franco+manno": "Franco–Manno",
  "grue+moss": "Grue–Moss",
  "katz+nickell": "Katz–Nickell",
  "lecuyer+street": "Lecuyer–Street",
  "kalita+nowosadzki": "Kalita–Nowosadzki",
  "cima+duboin": "Cima–Duboin",
  "meckstroth+rodwell": "Meckstroth–Rodwell",
  "brogeland+bakke": "Brogeland–Bakke",
  "klukowski+kalita": "Klukowski–Kalita",
};

// Any pool id -> a label ("pairslam:all" -> "Famous pairs · slams").
export function sourceLabel(id) {
  if (TOPIC_LABEL[id]) return TOPIC_LABEL[id];
  const m = /^(pairs|pair|pairslam):(.+)$/.exec(id || "");
  if (!m) return "Random";
  const who = m[2] === "all" ? "Famous pairs" : PAIR_LABEL[m[2]] || m[2];
  return m[1] === "pairslam" ? `${who} · slams` : who;
}
